/** @format */

import { defineCustomElements } from "@gsl/myselogerpro-web-components/loader";
import BFFClient, {
  NavigationGetNavigationControllerResponse,
} from "_clients/BFFClient";
import Cookie from "js-cookie";
import React, { useEffect, useRef, useState } from "react";

import {
  filteringTabBar,
  generateSidebarStructure,
} from "../../../shared/helpers";

import { useAuthentication } from "@aviv-pro-navigation/authentication";
import {
  ChangeUrlQueryValues,
  GetQueryValues,
} from "_shared/helpers/routerHelper";
import { useRelativeRouter } from "_shared/hooks/useRelativeRouter";
import { NextRouter } from "next/router";
import { NetworkSelection } from "../../molecules";
import {
  Network,
  Networks,
} from "../../molecules/NetworkSelection/NetworkSelection.types";
import { NavigationProps } from "./Navigation.types";
type InnerProps = NavigationProps;

const Navigation = (props: InnerProps) => {
	const HYPERVISEUR = "hyperviseur"
	const router = useRelativeRouter()
	const { onLoad, isNavigationHidden = false } = props
	const networkId = GetQueryValues(router.asPath).networkId as string

	const sideBarRef = useRef<HTMLMwcSidebarElement>(null)
	const tabBarRef = useRef<HTMLMwcTabbarElement>(null)
	const routerRef = useRef<NextRouter>(null)
	const [networks, setNetworks] = useState<Networks>(null)
	let controller = new AbortController();
	let signal = controller.signal;
  const { signOut  } = useAuthentication();

	routerRef.current = router
	useEffect(() => {
		defineCustomElements()
	}, [])


	const logout = () => {
		signOut();
	}

  const setUserInfo = async (
    data: NavigationGetNavigationControllerResponse
  ) => {
    const userInfo = data.currentUser;

    tabBarRef.current.userInformations = userInfo && {
      name: userInfo.firstName + " " + userInfo.lastName,
      mail: userInfo?.email,
      agence: data.intermediaryName,
      id: userInfo.login,
    };
    tabBarRef.current.structure = { account: [], menu: [], help: [] };
    filteringTabBar(data).then((res) => {
      tabBarRef.current.structure = res;
    });
  };

  const setNetworksFromDataApi = (
    data: NavigationGetNavigationControllerResponse
  ) => {
    if (data?.networks) {
      setNetworks(data.networks.map((n) => ({ name: n.name ?? "", id: n.id })));
    }
  };

  const onSelectNetwork = (n: Network) => {
    const newUrl = n.id
      ? ChangeUrlQueryValues("home", {
          networkId: n.id,
          productId: undefined,
          marketId: undefined,
        })
      : "home";
    router.push(newUrl);
  };

  useEffect(() => {
    let isCanceled = false;
    const controller = new AbortController();
    const signal = controller.signal;

    const fetchNavigationInfo = async (networkId) => {
      const call = networkId
        ? BFFClient.getNavigationInformations(networkId, undefined, signal)
        : BFFClient.getNavigationInformationsForIndependant(undefined, signal);
      return await call;
    };

    let navigationResponse: NavigationGetNavigationControllerResponse;

    const RefreshNavigationInformations = async () => {
      let navigationApiResult = await fetchNavigationInfo(networkId);
      if (isCanceled) return;
      navigationResponse = navigationApiResult?.result;

      if (!navigationResponse) return;
      setNetworksFromDataApi(navigationResponse);
      if (tabBarRef.current) {
        await setUserInfo(navigationResponse);
      }
      if (sideBarRef.current) {
        const sidebarStructure = await generateSidebarStructure(
          navigationResponse
        );
        requestAnimationFrame(() => {
          setTimeout(() => {
            if (isCanceled) return;
            sideBarRef.current.structure = sidebarStructure;
          }, 0);
        });
      }

      onLoad();
    };

    RefreshNavigationInformations();

    const routingRequestHandler = async (event: any) => {
      if (!event.detail) {
        return;
      }

			const url = event.detail?.route
			if (event.detail.id === "logout") {
				logout()
			}
			if (event.detail.id === "changeIdentity") {
				window.location.assign(event.detail.route)
				return
			}
			if (event.detail.id === "resetIdentity") {
				await BFFClient.resetImpersonatedSuperAdmin(undefined).then(
					response => {
						if (response) {
							const baseUrl: any =
								process.env.NEXT_PUBLIC_MY_SELOGER_PRO_URL +
								"/dashboard"
							window.location = baseUrl
						}
					}
				)
				return
			}
			if (event.detail.targetBlank) {
				// Make sure we take the external url to route outside the app
				window.open(
					navigationResponse.applicationsURL.find(
						item => item.code === event.detail.id
					).app.url
				)
				return
			}
			routerRef.current.push(url)
		}

    window.addEventListener("routingRequest", routingRequestHandler);

    return () => {
      isCanceled = true;
      window.removeEventListener("routingRequest", routingRequestHandler);
      if (!controller.signal.aborted) controller.abort();
    };
  }, [sideBarRef, tabBarRef, networkId, onLoad, routerRef]);
  return (
    <section
      className={
        networks && networks.length > 1 ? "network-selection-visible" : ""
      }
      style={{ display: isNavigationHidden ? "none" : "block" }}
    >
      {
        <>
          <mwc-tabbar
            active-item-id={HYPERVISEUR}
            ref={tabBarRef}
            myselogerpro-img="icon_myselogerpro"
            data-testid="tabBar-test-id"
          />
          <NetworkSelection
            networks={networks}
            onSelect={onSelectNetwork}
            selectedNetworkId={networkId}
          />

          <mwc-sidebar ref={sideBarRef} data-testid="sideBar-test-id" />
        </>
      }
    </section>
  );
};

export default Navigation;
